import { useState } from "react";
import { ChevronDown, Lightbulb } from "lucide-react";

interface TripAdvisorPanelProps {
  advisor: { text: string } | null;
}

/* Collapsible "Trip Advisor" — an indigo-tinted note with the backend's
   free-text guidance (RT-vs-one-way, transfer tips, timing). Self-hides when
   there's nothing to say. */
export default function TripAdvisorPanel({ advisor }: TripAdvisorPanelProps) {
  const [open, setOpen] = useState(false);
  const text = advisor?.text?.trim();
  if (!text) return null;

  return (
    <div className="overflow-hidden rounded-lg border border-indigo-200 bg-indigo-50/60">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm font-medium text-indigo-800 transition-colors hover:bg-indigo-100/60"
      >
        <span className="flex items-center gap-2">
          <Lightbulb className="h-4 w-4" aria-hidden="true" />
          Trip Advisor
        </span>
        <ChevronDown
          className={"h-4 w-4 transition-transform " + (open ? "rotate-180" : "")}
          aria-hidden="true"
        />
      </button>
      {open && (
        <div className="border-t border-indigo-200 px-3 py-2.5 text-sm leading-relaxed text-indigo-900/90 whitespace-pre-line">
          {text}
        </div>
      )}
    </div>
  );
}
